//@ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { Table } from 'antd';
import Button from 'components/Button';
import ErrorIndicator from 'components/ErrorIndicator';
import Spinner from 'components/Spinner';
import { useState } from 'react';
import HTTPClient from 'services/HTTPClient';
import QuizMetricsModal from './QuizMetricsModal';
import AssignQuestionsModal from './AssignQuestionsModal';
import AssignLessonPlanModal from './AssignLessonPlanModal';
import { showErrorToast } from 'utils';

export interface Account {
    id: number;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    grade: string;
    state: string;
    walletBalance: null | number;
}

export function getAccountName(account: Account) {
    return account.firstName || account.username
}

export const fetchAccounts = async (filters) => {
    const url = `/api/tenant/users`
    let query = {
        "sort": "id:asc",
        ...filters
    }
    console.log(query)
    let response = await HTTPClient.get().getJSONResult(url, query)
    console.log(response)
    return response.map(a => ({ ...a, key: a.id }))
}

const useAccounts = (filters = {}) => {
    return useQuery<Account[]>(['accounts'], () => fetchAccounts(filters));
};

const getColumns = (accounts) => {
    return [
        // {
        //     title: 'id',
        //     dataIndex: 'id',
        //     key: 'id',
        // },
        {
            title: 'S.No.',
            render: (item, _, index) => {
                return <div>{index + 1}</div>
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: 'Grade',
            dataIndex: 'grade',
            key: 'grade',
            filters: [...new Set(accounts.map(a => a.grade))].map(g => ({ text: g, value: g })),
            onFilter: (value: string, record) => record.grade?.indexOf(value) === 0,

        },
        // {
        //     title: 'State',
        //     dataIndex: 'state',
        //     key: 'state',
        //     filters: [...new Set(accounts.map(a => a.state))].map(s => ({ text: s, value: s })),
        //     onFilter: (value: string, record) => record.state?.indexOf(value) === 0,
        // },
        {
            title: 'Wallet Balance',
            dataIndex: 'walletBalance',
            key: 'walletBalance',
        },
    ]
};

export default function ManageAccounts() {
    const [selectedRows, setSelectedRows] = useState([]);
    const [showMetrics, setShowMetrics] = useState(false)
    const [showAssignQuestionsModal, setShowAssignQuestionsModal] = useState(false)
    const [showAssignLessonPlanModal, setShowAssignLessonPlanModal] = useState(false)

    const { data: accounts, isFetching, error, refetch } = useAccounts();
    if (error || isFetching) {
        return <div className="column mx-4" style={{ overflow: "auto" }}>
            {isFetching ? <div className="center">
                <Spinner className='mt-6' />
            </div> : null}
            {error ? <ErrorIndicator error={error} /> : null}
        </div>
    }
    return (
        <div className='mx-0 px-5 py-5' style={{ height: "100vh", overflow: "auto" }}>
            <div className='between mb-5'>
                <div>
                    <h3 className='is-size-3'>
                        <strong>Assign Lessons</strong>
                    </h3>
                    <small>Select users and assign lessons and quizzes</small>
                </div>
                <div>
                    <Button className='mr-2' onClick={() => {
                        if (!selectedRows.length) {
                            showErrorToast("Please select users first!")
                            return
                        }
                        setShowAssignLessonPlanModal(true)
                    }}>Assign Lesson Plan</Button>
                    <Button className='mr-2' onClick={() => {
                        if (!selectedRows.length) {
                            showErrorToast("Please select users first!")
                            return
                        }
                        setShowAssignQuestionsModal(true)
                    }}>Assign Quizzes</Button>
                    <Button onClick={() => {
                        if (!selectedRows.length) {
                            showErrorToast("Please select users first!")
                            return
                        }
                        setShowMetrics(true)
                    }}>View Metrics</Button>
                </div>
            </div>
            <Table
                rowSelection={{
                    onChange: (newSelectedRowKeys: React.Key[], selectedRows: DataType[]) => {
                        console.log(`selectedRowKeys: ${newSelectedRowKeys}`, 'selectedRows: ', selectedRows);
                        setSelectedRows(selectedRows);
                    },
                    getCheckboxProps: (record: DataType) => ({
                        name: record.name,
                    }),
                }}
                dataSource={accounts}
                columns={getColumns(accounts)}
                pagination={{
                    defaultPageSize: 100
                }}
            />
            {showMetrics && <QuizMetricsModal
                users={selectedRows.length > 0 ? selectedRows : accounts}
                onClose={() => setShowMetrics(false)}
            />}
            {showAssignQuestionsModal && <AssignQuestionsModal
                users={selectedRows.length > 0 ? selectedRows : accounts}
                onClose={() => setShowAssignQuestionsModal(false)}
            />}
            {showAssignLessonPlanModal && <AssignLessonPlanModal
                users={selectedRows.length > 0 ? selectedRows : accounts}
                onClose={() => setShowAssignLessonPlanModal(false)}
            />}
        </div>
    )
} 